export enum Attori {
  Risorsa = 1,
  ResponsabileGerarchico,
  ResponsabileCommessaDestinazione,
  ResponsabilePrimoLivello,
  PianificazioneControllo,
  ControllerCentrale,
  ControllerBU,
  COO,
  CFO,
  DirettoreGenerale,
}
